class MonadicError extends Error{constructor(m,p,e,a,c){super(m);this.name='MonadicError';this.path=p;this.expected=e;this.actual=a;this.callStack=c}};
function typeError(p,e,v){const a=v===null?'null':typeof v;const err=new MonadicError('Expected '+e+" for '"+p+"', got "+a,p,e,a);const c=globalThis.__tjs?.getConfig?.();if(c?.logTypeErrors)console.error('[TJS TypeError] '+err.message);if(c?.throwTypeErrors)throw err;return err};
function isMonadicError(v){return v instanceof Error&&v.name==='MonadicError'&&'path' in v};
const __stack=[];function pushStack(n){__stack.push(n)}function popStack(){__stack.pop()}function getStack(){return[...__stack]};
function Type(d,p,e){const t={description:d,__runtimeType:true};if(typeof p==='function'){t.check=p;t.default=e??null}else{const ex=e??p;t.default=ex;t.check=v=>{if(ex===null)return true;return typeof v===typeof ex}}return t};
const __tjs = globalThis.__tjs?.createRuntime?.() ?? {typeError,isMonadicError,pushStack,popStack,getStack,Type};
/* tjs <- dom.ts */

import { cloneWithBindings } from './metadata'

import { ContentType, ValueElement } from './xin-types'

/* line 4 */
export function dispatch(target,type) {
  try {
  __tjs.pushStack('dom.ts:8:dispatch');
  if (target instanceof Error) return target;
  if (type instanceof Error) return type;
  if ((typeof target !== 'object' || target === null || Array.isArray(target))) return __tjs.typeError('dom.ts:8:dispatch.target', 'object', target);
  if (typeof type !== 'string') return __tjs.typeError('dom.ts:8:dispatch.type', 'string', type);

    const event = new Event(type);
    target.dispatchEvent(event);

  } finally { __tjs.popStack(); }
}
dispatch.__tjs = {
  "params": {
    "target": {
      "type": {
        "kind": "object",
        "shape": {}
      },
      "required": true,
      "default": null
    },
    "type": {
      "type": {
        "kind": "string"
      },
      "required": true,
      "default": null
    }
  },
  "source": "dom.ts:8"
}

/* line 9 */
function valueType(element) {
  try {
  __tjs.pushStack('dom.ts:9:valueType');
  if (element instanceof Error) return element;
  if ((typeof element !== 'object' || element === null || Array.isArray(element))) return __tjs.typeError('dom.ts:9:valueType.element', 'object', element);

    if (element instanceof HTMLInputElement) {
        return element.type;
    }
    else if (element instanceof HTMLSelectElement &&
        element.hasAttribute('multiple')) {
        return 'multi-select';
    }
    else {
        return 'other';
    }

  } finally { __tjs.popStack(); }
}
valueType.__tjs = {
  "params": {
    "element": {
      "type": {
        "kind": "object",
        "shape": {}
      },
      "required": true,
      "default": null
    }
  },
  "returns": {
    "type": {
      "kind": "string"
    }
  },
  "unsafeReturn": true,
  "source": "dom.ts:9"
}

/* line 22 */
export function setValue(element, newValue) {
  try {
  __tjs.pushStack('dom.ts:28:setValue');
  if (element instanceof Error) return element;
  if (newValue instanceof Error) return newValue;
  if ((typeof element !== 'object' || element === null || Array.isArray(element))) return __tjs.typeError('dom.ts:28:setValue.element', 'object', element);

    switch (valueType(element)) {
        case 'radio':
            element.checked =
                element.value === newValue;
            break;
        case 'checkbox':
            element.checked = !!newValue;
            break;
        case 'date':
            element.valueAsDate = new Date(newValue);
            break;
        case 'multi-select':
            for (const option of Array.from(element.querySelectorAll('option'))) {
                option.selected = newValue[option.value];
            }
            break;
        default:
            element.value = newValue;
    }

  } finally { __tjs.popStack(); }
}
setValue.__tjs = {
  "params": {
    "element": {
      "type": {
        "kind": "object",
        "shape": {}
      },
      "required": true,
      "default": null
    },
    "newValue": {
      "type": {
        "kind": "any"
      },
      "required": false
    }
  },
  "source": "dom.ts:28"
}

const PickMap = Type('PickMap')

/* line 49 */
/* TODO: TS types degraded — element: ValueElement */
export function getValue(element) {
  try {
  __tjs.pushStack('dom.ts:54:getValue');
  if (element instanceof Error) return element;

    switch (valueType(element)) {
        case 'radio': {
            const radio = element.parentElement?.querySelector(`[name="${element.name}"]:checked`);
            return radio != null ? radio.value : null;
        }
        case 'checkbox':
            return element.checked;
        case 'date':
            return element.valueAsDate?.toISOString();
        case 'multi-select':
            return Array.from(element.querySelectorAll('option')).reduce((map, option) => {
                map[option.value] = option.selected;
                return map;
            }, {});
        default:
            return element.value;
    }

  } finally { __tjs.popStack(); }
}
getValue.__tjs = {
  "params": {
    "element": {
      "type": {
        "kind": "any"
      },
      "required": true
    }
  },
  "source": "dom.ts:54"
}

const { ResizeObserver } = globalThis;

export const resizeObserver = ResizeObserver != null
    ? new ResizeObserver((entries) => {
        for (const entry of entries) {
            const element = entry.target;
            dispatch(element, 'resize');
        }
    })
    : {
        observe() { },
        unobserve() { },
    };

/* line 88 */
/* TODO: TS types degraded — content: ContentType | null | undefined */
export function appendContentToElement(elt, content, cloneElements = true) {
  try {
  __tjs.pushStack('dom.ts:90:appendContentToElement');
  if (elt instanceof Error) return elt;
  if (content instanceof Error) return content;
  if (cloneElements instanceof Error) return cloneElements;
  if (((elt !== null && (typeof elt !== 'object' || elt === null || Array.isArray(elt))) && elt !== undefined)) return __tjs.typeError('dom.ts:90:appendContentToElement.elt', 'object | undefined', elt);
  if (cloneElements !== undefined && typeof cloneElements !== 'boolean') return __tjs.typeError('dom.ts:90:appendContentToElement.cloneElements', 'boolean', cloneElements);

    if (elt != null && content != null) {
        if (typeof content === 'string') {
            elt.textContent = content;
        }
        else if (Array.isArray(content)) {
            content.forEach((node) => {
                elt.append(node instanceof Node && cloneElements ? cloneWithBindings(node) : node);
            });
        }
        else if (content instanceof Node) {
            elt.append(cloneElements ? cloneWithBindings(content) : content);
        }
        else {
            throw new Error('expect text content or document node');
        }
    }

  } finally { __tjs.popStack(); }
}
appendContentToElement.__tjs = {
  "params": {
    "elt": {
      "type": {
        "kind": "union",
        "members": [
          {
            "kind": "object",
            "nullable": true,
            "shape": {}
          },
          {
            "kind": "undefined"
          }
        ]
      },
      "required": true,
      "default": null
    },
    "content": {
      "type": {
        "kind": "any"
      },
      "required": false
    },
    "cloneElements": {
      "type": {
        "kind": "boolean"
      },
      "required": false,
      "default": true
    }
  },
  "source": "dom.ts:90"
}